// src/pages/GuidePage.jsx
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CardDetailModal from '../components/CardDetailModal';

const GuidePage = ({ onBack }) => {
  const cards = useSelector((state) => state.tarot.cards);
  const [selectedCard, setSelectedCard] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterSuit, setFilterSuit] = useState('all');

  const suits = ['all', 'Major Arcana', 'Wands', 'Cups', 'Swords', 'Pentacles'];
  const suitLabels = {
    all: '✦ Todas',
    'Major Arcana': '⭐ Arcanos Mayores',
    Wands: '🔥 Bastos',
    Cups: '💧 Copas',
    Swords: '⚔️ Espadas',
    Pentacles: '🌿 Oros',
  };

  const filteredCards = cards.filter((card) => {
    const matchesSearch = card.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesSuit = filterSuit === 'all' || card.suit === filterSuit ||
      (filterSuit === 'Major Arcana' && !card.suit);
    return matchesSearch && matchesSuit;
  });

  return (
    <div className="page-container">
      <div className="guide-header">
        <h2 className="page-title font-cinzel">Guía del Tarot</h2>
        <p className="page-subtitle">
          Explora el significado de las 78 cartas del Tarot Rider-Waite. Haz clic en cualquier carta para ver su interpretación completa.
        </p>
      </div>

      {/* Filters */}
      <div className="guide-filters">
        <div className="guide-search-wrapper">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Buscar carta por nombre..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="guide-search-input"
          />
          {searchTerm && (
            <button className="search-clear" onClick={() => setSearchTerm('')}>✕</button>
          )}
        </div>
        <div className="guide-suit-filter">
          {suits.map((suit) => (
            <button
              key={suit}
              onClick={() => setFilterSuit(suit)}
              className={`suit-tab ${filterSuit === suit ? 'suit-tab--active' : ''}`}
            >
              {suitLabels[suit]}
            </button>
          ))}
        </div>
      </div>

      <p className="guide-count">{filteredCards.length} cartas</p>

      {/* Cards Grid */}
      <div className="guide-grid">
        {filteredCards.map((card) => (
          <button
            key={card.id}
            className="guide-card"
            onClick={() => setSelectedCard(card)}
          >
            <div className="guide-card-img-wrapper">
              <img
                src={card.image}
                alt={card.name}
                className="guide-card-img"
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://placehold.co/100x175/1e1b4b/d8b4fe?text=🔮';
                }}
              />
            </div>
            <div className="guide-card-info">
              <h3 className="guide-card-name font-cinzel">{card.name}</h3>
              <p className="guide-card-suit-label">
                {card.suit ? card.suit : 'Arcano Mayor'}
              </p>
              <p className="guide-card-preview">{card.meaning_up?.substring(0, 80)}...</p>
            </div>
          </button>
        ))}
      </div>

      {filteredCards.length === 0 && (
        <div className="guide-empty">
          <p>🔍 No se encontraron cartas para "{searchTerm}"</p>
          <button className="main-button secondary-button" onClick={() => { setSearchTerm(''); setFilterSuit('all'); }}>
            Limpiar filtros
          </button>
        </div>
      )}

      {selectedCard && (
        <CardDetailModal card={selectedCard} onClose={() => setSelectedCard(null)} />
      )}

      <button onClick={onBack} className="main-button secondary-button back-btn">
        ← Volver al Inicio
      </button>
    </div>
  );
};

export default GuidePage;
